import { keyframes, styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import {
  detailsBrandBlueWhenOpenVar,
  detailsCalloutGreyWhenOpenVar,
  detailsOneWhenClosedZeroWhenOpenVar,
} from '#/components/Details/detailsCssVariables';
import { colors, cssBreakpoints, spacing, transition } from '#/theme/theme';

const blueGreenAnimation = keyframes`
  0% { background: ${colors.brandBlue}; }
  40% { background: ${colors.brandGreen}; }
  60% { background: ${colors.brandGreen}; }
  100% { background: ${colors.brandBlue}; }
`;

export const StyledLayoutHeaderButton = styled(ButtonOrLink)`
  color: ${colors.white};
  transition: ${transition};
  display: inline-flex;
  align-items: center;
  height: 38px;
  font-size: 15px;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;
  user-select: none;

  padding: 0 ${spacing[12]};
  &[data-small-horizontal-padding] {
    padding: 0 ${spacing[8]};
  }

  justify-content: space-between;
  &[data-center-horizontally] {
    justify-content: center;
  }

  > * {
    /* Avoid mouseover triggering while when hovering over other elements */
    pointer-events: none;
  }

  &:hover {
    text-decoration: none;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    border-radius: 6px;

    &[data-round-bottom-when-open] {
      border-radius: 6px 6px
        calc(var(${detailsOneWhenClosedZeroWhenOpenVar}, 1) * 6px)
        calc(var(${detailsOneWhenClosedZeroWhenOpenVar}, 1) * 6px);
    }
  }

  &[data-variant='blue'] {
    color: ${colors.white};
    background: ${colors.brandBlue};
    outline-color: ${colors.hoverBlue};

    &:hover {
      color: ${colors.white};
      background: ${colors.hoverBlue};
    }
  }

  &[data-variant='grey'] {
    color: var(${detailsBrandBlueWhenOpenVar}, ${colors.darkContentGrey});
    background: var(${detailsCalloutGreyWhenOpenVar});

    &:hover {
      background: ${colors.selectionGrey};
    }

    &:is(a):hover {
      color: ${colors.brandBlue};
    }
  }

  &[data-variant='secondary'] {
    border: 1px solid ${colors.brandBlue};
    color: ${colors.brandBlue};
    background: var(${detailsCalloutGreyWhenOpenVar});

    &:hover {
      background-color: ${colors.softBlue};
    }

    &:is(a):hover {
      color: ${colors.brandBlue};
    }
  }

  &[data-variant='green'] {
    color: ${colors.white};
    background: ${colors.brandGreen};
  }

  &[data-variant='white'] {
    color: ${colors.lightContentGrey};
    background: ${colors.white};
  }

  &[data-variant='blueGreenAnimate'] {
    color: ${colors.white};
    background: ${colors.brandBlue};
    animation: ${blueGreenAnimation} 1.5s;
  }
`;
